<template>
  <div id="billing-order-concession-page">
    <q-page-container style="max-height: 85vh" class="scroll">
      <div class="full-height">
        <div class="row container-crud q-px-sm">
          <div class="fit">
            <q-card class="q-px-sm">
              <q-card-section class="q-py-xs">
                <div v-if="name === 'btPesquisar'" class="crud-title">
                  <translate>SEARCH_RECORDS</translate>
                </div>
                <div v-else-if="name === 'btNovo'" class="crud-title">
                  <translate>NEW_REGISTRATION</translate>
                </div>
                <div
                  v-else-if="forms[0].nmInterface.indexOf('.alterar') > 0"
                  class="crud-title"
                >
                  <translate>UPDATE_REGISTRATION</translate>
                </div>
                <div v-else-if="labelPage" class="crud-title">
                  {{ labelPage }}
                </div>
              </q-card-section>
              <q-card-section class="q-px-md">
                <crud-form
                  v-if="forms"
                  ref="form"
                  :form="forms[0]"
                  :model="forms[0].dadosForm"
                  :forms="forms[0].relacionamentos"
                  class="row"
                >
                  <crud-input
                    class="col-4 q-px-sm"
                    nmInput="concessionContract"
                  />
                  <crud-input
                    class="col-2 q-px-sm"
                    nmInput="year"
                  />
                  <crud-input
                    class="col-2 q-px-sm"
                    nmInput="month"
                  />
                </crud-form>
                <jt-data-table
                  :ref="'jtDataTable'"
                  :api-mode="false"
                  :data="contracts"
                  :buttons="getButtons('contracts')"
                  :fields="getColumns('contracts')"
                  :is-paginated="false"
                  row-buttons
                  noneselect
                  @action-button="actionButtonTable"
                />
              </q-card-section>
            </q-card>
          </div>
        </div>

        <div
          v-if="forms[0] && forms[0].buttons.length > 0"
          class="row full-width q-col-gutter-lg justify-center q-py-md"
        >
          <div class="col-lg-2 col-md-3">
            <q-btn class="full-width" color="grey-7" @click="limparForm">
              <translate>CLEAN</translate>
            </q-btn>
          </div>
          <div
            v-for="(button, i) in forms[0].buttons"
            :key="i"
            :class="`col-lg-2 col-md-3 button-${
              button.name ? button.name.toLowerCase() : button.name
            }`"
          >
            <q-btn
              :class="`full-width button-btn-${
                button.name ? button.name.toLowerCase() : button.name
              }`"
              color="info"
              @click="actionButton(button)"
            >
              <q-icon
                v-if="button.icon"
                :name="button.icon"
                size="18px"
                class="position-icon-filter"
              />
              {{ button.label }}
            </q-btn>
          </div>
        </div>
      </div>
    </q-page-container>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDynamicForm, JtDataTable } from 'jtech-webcomps'
const { modal, form, input } = JtCrud

@Component({
  name: 'BillingOrderConcessionPage',
  components: {
    JtDataTable,
    JtDynamicForm,
    'crud-modal': modal,
    'crud-form': form,
    'crud-input': input
  },
  props: {
    label: String,
    forms: { type: Array, required: true },
    params: Object,
    parent: Object,
    show: {
      type: Boolean,
      default: false
    },
    detail: {
      type: Boolean,
      default: false
    },
    maximized: {
      type: Boolean,
      default: false
    }
  }
})
class BillingOrderConcessionPage extends Vue {
  contracts = [];
  invoices = [];
  getColumns (name) {
    return this.forms[0].inputs.find(
      (x) => x.type == 'DATATABLE' && x.name.includes(name)
    ).columns
  }

  getButtons (name) {
    return this.forms[0].inputs.find(
      (x) => x.type == 'DATATABLE' && x.name.includes(name)
    ).buttons
  }

  getData (name) {
    return this.forms[0].relacionamentos[name]
  }

  setData (name, data) {
    this[name] = data
    this.forms[0].relacionamentos[name] = data
  }

  async actionButtonTable (button, params) {
    this.$emit('action-button', button, params, this)
  }

  actionButton (button) {
    if (!this.isButtonValidForm(button) || this.isValidForm()) {
      this.$emit('action-button', button, this.getParams(), this)
    } else {
      this.$emit('show-message', 'warning', 'REQUIRED_FIELDS_NOT_FILLED', this)
    }
  }

  actionButtonComposition (button) {
    this.$emit('composition-button-click', button)
  }

  compositionModalCloseHandler (f) {
    this.$emit('composition-modal-close', f)
  }

  isButtonValidForm (button) {
    return button.name.indexOf('btCancelar') < 0
  }

  isValidForm () {
    return Array.isArray(this.$refs.form)
      ? this.$refs.form[0].isValidForm()
      : this.$refs.form.isValidForm()
  }

  getParams () {
    return this.forms[0].dadosForm
  }

  limparForm () {
    Array.isArray(this.$refs.form)
      ? this.$refs.form[0].resetForm()
      : this.$refs.form.resetForm()
    this.setData('contracts', [])
    this.$emit('form-reset', { form: this.$refs.form, page: this })
  }
}
export default BillingOrderConcessionPage
</script>
<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
